import Modal from 'trunks/vue/admin/components/modals/modal.js';
import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';
import SearchGroup from './search_groups.js';
import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

const HOLD_FIELDS = [
  { id: -2, title: '填写用户', type: 'Field::HoldUser' },
  { id: -1, title: '填写时间', type: 'Field::HoldCreatedAt' },
];

export default Vue.extend({
  components: {
    modal: Modal,
    RichTextEditor,
    searchGroup: SearchGroup,
    FilterOptions,
  },

  props: {
    dataclipableGID: {
      type: Skylark.Libs.GlobalID,
      required: true,
    },

    searchSettings: {
      type: Object,
      default: {},
    },

    fields: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      searchGroups: this.searchSettings.search_groups || [],
      description: this.searchSettings.description || '',
      popoverFieldOptions: this._generatePopoverFieldOptions(),
    };
  },

  template: `
    <modal title="数据搜索设置" ref='modal'>
      <div class="modal-body">
        <div class="response-search-setting">
          <div class="setting-header justify-box">
            <label class="switch">
              <input type="checkbox" v-model="searchSettings.enable" />
              <span></span>
            </label>
            <span>开启数据搜索</span>
          </div>
          <div class="setting-tip">章节、文件、定位字段不支持搜索</div>
        </div>

        <div class="form-search-setting-body" :class="{ 'disabled': !searchSettings.enable }">
          <div class="form-field mb-6">
            <div class="form-field-head">
              <div class="form-field-title">搜索地址：</div>
            </div>
            <div class="form-field-input-container justify-box">
              <input class="form-field-value mr-4"
                     type="text"
                     :value='search_link'
                     ref="inputRef"
                     readonly />
              <div class="btn icon-btn" @click="copyLink">
                <i class="slp-copy"></i>
              </div>
              <a class="btn icon-btn" target="_blank" :href='share_link'>
                <i class="slp-right-up-square"></i>
              </a>
            </div>
          </div>

          <div class="form-field mb-6">
            <div class="form-field-head">
              <div class="form-field-title">自定义搜索标题：</div>
            </div>
            <div class="form-field-input-container">
              <input v-model.trim='searchSettings.title'
                     class="form-field-value"
                     type="text"
                     placeholder="未命名表单"/>
            </div>
          </div>

          <div class="form-field mb-6">
            <div class="form-field-head">
              <div class="form-field-title">自定义结果字段：</div>
            </div>
            <div class="form-field-input-container">
              <FilterOptions :multiple='true'
                             :groupedOptions='[{ options: popoverFieldOptions }]'
                             @valueChanged="valueChangedFunc"
                             ref='fieldOpionSelectionRef' />
            </div>
          </div>

          <div class="form-field mb-6">
            <div class="form-field-head">
              <div class="form-field-title">自定义搜索描述：</div>
            </div>
            <div class="form-field-input-container">
              <RichTextEditor placeholder="请输入自定义的描述文案"
                              :menuSticky='false'
                              :value='description'
                              ref="editorRef" />
            </div>
          </div>
          <div class="form-field mb-6">
            <div class="form-field-head">
              <div class="form-field-title">自定义搜索条件：</div>
                <searchGroup v-for="(search_group, index) in searchGroups"
                             :key='search_group.id'
                             :searchGroupIndex='index'
                             :searchFactors='search_group.search_factors'
                             :popoverFieldOptions='popoverFieldOptions'
                             ref="searchGroupsRef" />
                <button class="outlined btn-primary mt-2 mb-2" @click="addSearchFactors">添加条件组</button>
              </div>
            </div>
        </div>
      </div>

      <div class="modal-footer" slot='footer'>
        <div class="left"></div>
        <div>
          <button class="outlined btn-default" @click='dismissModal'>取消</button>
          <button @click="saveFunc">确定</button>
        </div>
      </div>
    </modal>
  `,

  computed: {
    search_link() {
      return `${window.location.host}${this.share_link}`;
    },

    share_link() {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(`${this.dataclipableGID.toPath()}/responses/search`);
    },
  },

  methods: {
    dismissModal() {
      this.$refs.modal.close();
    },

    open() {
      this.$refs.modal.open();
    },

    copyLink() {
      Skylark.Libs.Clipboard.copy(this.$refs.inputRef);
      Skylark.Bridge.newAlertify('已复制', {
        type: 'success',
        duration: 3000,
      });
    },

    valueChangedFunc(filterOptions) {
      this.searchSettings.field_ids = [];
      _.each(filterOptions.selectedOptions, (item) => {
        this.searchSettings.field_ids.push(item.id);
      });
    },

    addSearchFactors() {
      const searchGroup = {
        id: Skylark.Helpers.Utilities.uuid(),
        search_factors: [{
          id: Skylark.Helpers.Utilities.uuid(),
          field_id: -2,
          field_type: 'Field::HoldUser',
          full_match: false,
        }],
      };

      this.searchGroups.push(searchGroup);
    },

    saveFunc() {
      Skylark.Libs.Ajax.patch(`/admin/${this.dataclipableGID.toPath()}/responses/search_settings`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          responses_search_settings: this._generateResponsesSearchSettings(),
        },
        success: () => {
          Skylark.Bridge.newAlertify('保存成功', {
            type: 'success',
            duration: 3000,
          });
          this.dismissModal();
        },
        error: () => {
          Skylark.Bridge.newAlertify('保存失败', {
            type: 'error',
            duration: 3000,
          });
        },
      });
    },

    _generateResponsesSearchSettings() {
      _.each(this.searchGroups, (group, index) => {
        group.search_factors = this.$refs.searchGroupsRef[index].getValue();
      });

      return {
        title: this.title,
        enable: this.searchSettings.enable,
        field_ids: this.searchSettings.field_ids,
        description: this.$refs.editorRef.getValue(),
        search_groups: this.searchGroups,
      };
    },

    _generatePopoverFieldOptions() {
      return _.reduce(HOLD_FIELDS.concat(this.fields), (memo, field) => {
        const selected = _.contains(this.searchSettings.field_ids, field.id);

        memo.push({
          id: field.id,
          name: field.title,
          type: field.type,
          _selected: selected,
        });

        return memo;
      }, []);
    },
  },
});
